module.exports = __webpack_public_path__ + "static/media/imageE.21984986.png";